import { Link, NakedButton } from 'roo-ui/components';
import { CONTACT_US_URL, CUSTOMER_SUPPORT_HOTLINE_AU, CUSTOMER_SUPPORT_HOTLINE_INTL } from 'config/constants';
import * as track from 'lib/gaTracking/crossPageEvents';
import { openLiveChat } from 'lib/liveChat/actions';
import TelLink from 'components/TelLink';

const onClickLiveChat = () => {
  track.invoiceDownloadFailedModalLinkSelected('live chat');
  openLiveChat();
};

export const downloadInvoiceErrorModalProps = {
  variant: 'error',
  header: 'Download failed',
  body: (
    <>
      An error occurred while downloading the invoice. Please check your browser settings for download permissions and try again.
      <br />
      <br />
      Otherwise, please contact us via{' '}
      <Link data-testid="livechat-support-link" as={NakedButton} onClick={onClickLiveChat} underline>
        live chat
      </Link>
      ,{' '}
      <Link
        data-testid="email-support-link"
        target="_blank"
        href={`${CONTACT_US_URL}`}
        onClick={() => track.invoiceDownloadFailedModalLinkSelected('email')}
        underline
      >
        email
      </Link>
      , or call{' '}
      <TelLink
        data-testid="call-support-link"
        number={CUSTOMER_SUPPORT_HOTLINE_AU}
        color="greys.steel"
        underline
        onClick={() => track.invoiceDownloadFailedModalLinkSelected('call customer support')}
      />{' '}
      (outside Australia:{' '}
      <TelLink
        data-testid="call-international-support-link"
        number={CUSTOMER_SUPPORT_HOTLINE_INTL}
        color="greys.steel"
        underline
        onClick={() => track.invoiceDownloadFailedModalLinkSelected('call international customer support')}
      />
      )
    </>
  ),
};
